import React from 'react';
import { compose, branch, withHandlers } from 'recompose';
import { duplicateProject, duplicateTaopixProject } from '../../Common/Providers/ProjectApi';
import { withSpinnerOnAjax } from '../../Common/Spinner';
import getEditingPath from '../../Common/Helpers/GetEditingPath';
import { isTaopixProject } from '../../Common/Helpers/CheckTaopixProject';
import { HTMLTrans, withTranslationProvider } from '../../Common/Translations';
import { withSupportEmail } from '../../Common/Helpers/SupportEmail';

export const withPrintboxReorder = compose(
  withSpinnerOnAjax('duplicateProject', duplicateProject),
  withHandlers({
    onClick: ({ duplicateProject, printboxUuid, tRoute, reorderedPbxDetail }) => () => {
      const projectId = reorderedPbxDetail ? reorderedPbxDetail.original_project_uuid : printboxUuid

      duplicateProject({ id: projectId }).done((resp) => {
        const {
          data: {
            id,
            family: {
              editor_module_id
            }
          }
        } = resp;
        window.location.href = tRoute(getEditingPath(id, editor_module_id));
      });
    }
  }),
);

export const withTaopixOnlineReorderOnClick = compose(
  withSpinnerOnAjax('duplicateTaopixProject', duplicateTaopixProject),
  withHandlers({
    onClick: ({ projectId : taopixProjectId, t, supportEmail, duplicateTaopixProject  }) => () => {
      duplicateTaopixProject({id: taopixProjectId, t, supportEmail })
        .done((response) => {
          window.location = response.data.redirect_to_cart_url;
        });
    },
  }),
);

export const withTaopixReorderable = WrappedComponent => (props) => {
  const { taopixReorderable = 'off' } = props;

  return (taopixReorderable !== 'on') ? null : <WrappedComponent {...props}/>;
};

export const withTaopixReorder = compose(
  withTaopixOnlineReorderOnClick,
  withTaopixReorderable
);

export const withReorder = compose(
  withTranslationProvider,
  withSupportEmail,
  branch(
    isTaopixProject,
    withTaopixReorder,
    withPrintboxReorder,
  )
);

const DuplicateButton = props => <button
  type="button"
  onClick={props.onClick}
  style={{ width: '140px' }}
  className='btn btn-outline-primary btn-sm'>
    <HTMLTrans id="account.order_duplicate_button">Duplicate</HTMLTrans>
</button>;

export default withReorder(DuplicateButton);



// WEBPACK FOOTER //
// ./src/Account/Order/Duplicate.js